import MerchantWhitelistBottomToolbar from './MerchantWhitelistBottomToolbar';

export default MerchantWhitelistBottomToolbar;